import React from "react";
import "../BarraSuperior.css";
import { useTranslation } from "react-i18next";
import { user } from "@core";

const MenuLanguagesComponent = ({ handleShowLanguagesMenu, controller, availableLanguages }) => {
  const { t, i18n } = useTranslation();

  const handleChangeLanguage = (l) => {
    const ev = new user.events.UpdateLanguage(l);
    controller.dispatch(ev);
    handleShowLanguagesMenu();
  };

  return (
    <div className="MenuDesplegable">
      {availableLanguages?.length > 0 &&
        availableLanguages.map((lang, i) => (
          <div
            key={i}
            className={"Button-Language " + (i18n.language && i18n.language.startsWith(lang) ? "Selected" : "")}
            onClick={() => handleChangeLanguage(lang)}
          >
            <span>{t(`lang.min.${lang}`)}</span>
          </div>
        ))}
    </div>
  );
};

export default MenuLanguagesComponent;
